import React from 'react';
import { useEffect, useState } from 'react';
import { GeekApi } from './interface';
import { toast } from 'react-toastify';
import * as FileSaver from 'file-saver';
import Excel from 'exceljs';
import { getDateTime } from './date';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { ButtonGroup } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

const GeekInventoryReport = () => {
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    GeekApi('incomp', {})
      .then(async (res) => {
        setData([...res]);
        setColumns(
          Object.keys(res[0]).map((key) => ({
            header:
              key === 'Geek'
                ? 'Count at Geek+ Location \n(From Geek System)'
                : key === 'ELM'
                  ? 'Count at Geek+ Location \n(From ELM System)'
                  : key,
            key: key,
          }))
        );
      })
      .catch((e) => {
        console.log('Error ' + e);
        toast.error('Please try again later');
      });
  }, []);

  const downloadReport = () => {
    const workbook = new Excel.Workbook(); // Create a new workbook
    const worksheet = workbook.addWorksheet('data');
    worksheet.columns = [...columns];
    worksheet.addRows([...data]);
    worksheet.getCell('B1').alignment = { wrapText: true };
    worksheet.getCell('C1').alignment = { wrapText: true };

    workbook.xlsx.writeBuffer().then(function (data) {
      var blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      FileSaver.saveAs(blob, 'Geek_Inventory' + getDateTime() + '.xlsx');
    });
  };

  return (
    <div className="main-container">
      <div className="mt-2 d-flex justify-content-between">
        {/* Page Title */}
        <h2>Geek+ Inventory Report</h2>
        <ButtonGroup className="mb-2">
          <Button
            variant="primary"
            className="ms-auto text-nowrap"
            onClick={downloadReport}
          >
            Download Report
          </Button>
        </ButtonGroup>
      </div>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer
          component={Paper}
          className="tableContainer"
          id="tab-container"
          style={{
            maxHeight: '75vh',
          }}
        >
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((col) => (
                  <TableCell key={col.key} className="table-header">
                    {col.header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, rowIndex) => (
                <TableRow key={rowIndex} hover tabIndex={-1}>
                  {columns.map((col) => (
                    <TableCell key={col.key}>{row[col.key]}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
};

export default GeekInventoryReport;
